export const DEFAULT_NODE_POSITION = { x: 0, y: 0 };

export const ROUTER_CONNECTION_LIMITS = {
  decideIfCouponsForTypeExist: 2,
  decideByWorkingHours: 2,
  decideByRecentLLMQuestionThreshold: 2,
  default: 99,
};

// * Block types the gate destination dropdown must not offer.
// *
// * version, entry, messenger_url_button, image and database have no handler -
// * Handler.ts returns early for them, so landing there stalls the conversation
// * with no message and no error.
// *
// * button and image are child elements of the block that contains them rather
// * than steps of their own. Across every client flow button appears 3103 times
// * inside a parent and only 5 times as a destination, and image never appears as
// * one. Landing on a button would also skip the payload handling that stores the
// * user's choice, so the question it belongs to would be bypassed.
// *
// * The database, gate and Decider blocks do run when landed on, but they are
// * plumbing rather than a point in the conversation - a gate should arrive at
// * the step the user actually sees, not in the middle of a data write or another
// * redirect.
// *
// * This list only governs what the dropdown offers. A destination already saved
// * on a block is left alone even when its type is on this list, so opening the
// * sidebar can never quietly discard existing routing.
export const NON_TARGETABLE_BLOCK_TYPES = [
  'version',
  'entry',
  'messenger_url_button',
  'image',
  'database',
  'button',
  'databaseUpdate',
  'databaseRead',
  'databaseDelete',
  'databaseChecker',
  'gate',
  'Decider',
];
